import { API_BASE } from '../config/api';
import { solvePow } from './pow';

interface MutationResponse {
  result: boolean;
  message: string;
}

const postAuth = async (path: string, body: any): Promise<any> => {
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => null);
  return { ok: res.ok, data };
};

/** Đăng ký công khai qua AgentX /auth (thay Cognito publicSignUp/confirmSignUp). */
export const publicRegistrationService = {
  async signUp(email: string, password: string): Promise<MutationResponse> {
    const pow = solvePow('register', email);
    const { ok, data } = await postAuth('/auth/register', { email, password, pow });
    if (ok && data?.ok) return { result: true, message: 'Verification code sent to your email' };
    return { result: false, message: data?.error || 'Sign up failed' };
  },

  async confirmSignUp(email: string, confirmationCode: string, _password: string): Promise<MutationResponse> {
    const { ok, data } = await postAuth('/auth/verify', { email, code: confirmationCode });
    if (ok && data?.ok) return { result: true, message: 'Account verified' };
    return { result: false, message: data?.error || 'Confirmation failed' };
  },

  async resendConfirmationCode(email: string): Promise<MutationResponse> {
    const pow = solvePow('register', email);
    const { ok, data } = await postAuth('/auth/resend-verification', { email, pow });
    if (ok && data?.ok) return { result: true, message: 'Verification code resent' };
    return { result: false, message: data?.error || 'Failed to resend code' };
  },
};
